export default "__VITE_ASSET__ChBpY6tb__"